/**
 * Local Storage Implementation for Organization (Projects & Tags)
 * Mirrors songStorage.js patterns for local-first storage
 */

const PROJECTS_KEY = "lyricToolkit_projects";
const TAGS_KEY = "lyricToolkit_tags";

// --- Projects ---

export const saveProjects = (projects) => {
  try {
    localStorage.setItem(PROJECTS_KEY, JSON.stringify(projects || []));
  } catch (error) {
    console.error("Error saving projects to localStorage:", error);
  }
};

export const loadProjects = () => {
  try {
    const stored = localStorage.getItem(PROJECTS_KEY);
    if (stored) {
      return JSON.parse(stored);
    }
  } catch (error) {
    console.error("Error loading projects from localStorage:", error);
  }
  return [];
};

// --- Tags ---

export const saveTags = (tags) => {
  try {
    localStorage.setItem(TAGS_KEY, JSON.stringify(tags || []));
  } catch (error) {
    console.error("Error saving tags to localStorage:", error);
  }
};

export const loadTags = () => {
  try {
    const stored = localStorage.getItem(TAGS_KEY);
    if (stored) {
      return JSON.parse(stored);
    }
  } catch (error) {
    console.error("Error loading tags from localStorage:", error);
  }
  return [];
};

// --- Clear ---

export const clearOrganization = () => {
  try {
    localStorage.removeItem(PROJECTS_KEY);
    localStorage.removeItem(TAGS_KEY);
  } catch (error) {
    console.error("Error clearing organization from localStorage:", error);
  }
};
